import { log } from './_logs'
import { sleep, checkUserInteraction } from './_utils'
import { initVumeter } from './audioMeter'

export { log }

export class VuMeter {
	constructor($element, {
		margin = 4,
		transparencyHigh = .8,
		transparencyLow = .2,
		clipLevel = .98,
		clipDuration = 250
	} = {}) {
		this.element = $element[0]

		const
			high = {
				green: `rgba(0,255,0,${transparencyHigh})`,
				yellow: `rgba(255,223,0,${transparencyHigh})`,
				red: `rgba(255,0,0,${transparencyHigh})`,
			},
			low = {
				green: `rgba(0,255,0,${transparencyLow})`,
				yellow: `rgba(255,223,0,${transparencyLow})`,
				red: `rgba(255,0,0,${transparencyLow})`,
			}

		Object.assign(this, {
			margin,
			transparencyHigh,
			transparencyLow,
			high,
			low,
			clipLevel,
			clipDuration
		})
		return this.init()
	}

	async init() {
		const { element } = this

		// const audio = document.createElement('audio')
		const audio = this.element.querySelector('audio')

		//	20s to find a <video/> child with src
		const timeLimit = performance.now() + 20000

		let video
		do {
			video = this.element.querySelector('video')
			if (timeLimit < performance.now()) {
				// this.stop()
				console.warn('vuemeter init timeout, unable to find a child video element in time, but it\'s propably fine')
				return;
				// throw new Error('TIMEOUT : unable to find a child video element in time')
			}
			await sleep(500)
		} while (!video || !(video.srcObject || video.src)) // tant qu'on n’a pas de <video/> avec une src ou srcObject 



		if (!checkUserInteraction()) {
			log('user has not interacted with the page')
			return false
		}



		if (video.muted && !video.srcObject) {
			video.muted = false
		}


		const canvas = this.element.querySelector(`canvas`)

		log('got a canvas elt', canvas)

		this.canvasContext = canvas.getContext('2d')
		if (canvas.clientHeight != canvas.height) {
			canvas.height = canvas.clientHeight
		}
		if (canvas.clientWidth != canvas.width) {
			canvas.width = canvas.clientWidth
		}

		let resizeDebounce
		const resize = e => {

			if (resizeDebounce) {
				clearTimeout(resizeDebounce)
			}

			resizeDebounce = setTimeout(_ => {
				requestAnimationFrame(_ => {
					if (canvas.clientHeight != canvas.height) {
						canvas.height = canvas.clientHeight
					}
					if (canvas.clientWidth != canvas.width) {
						canvas.width = canvas.clientWidth
					}
				})
			}, 100)
		}
		$(window).on('resize', resize)

		this.destroy = () => {
			$(window).off('resize', resize)
		}

		// video.addEventListener('play', () => {

		// console.info('video play event')

		// if (video.muted) {
		// 	console.log(video)
		// 	video.pause()
		// 	return
		// }


		if (video.srcObject) {
			this.srcObject = true
		}
		log('starting vumeter audio processor')

		const { analyser, analyserLeft, analyserRight, audioContext, source, noAudio } = await initVumeter(video, canvas, audio, {})

		// console.warn( { analyser, audioContext, noAudio })

		if (noAudio) {
			return { noAudio: true }
		}
		else if (!analyser || !audioContext) {
			return
		}
		const dataArray = new Uint8Array(analyser.frequencyBinCount)
		const dataArrayRight = new Uint8Array(analyserRight.frequencyBinCount)

		Object.assign(this, { analyser, analyserRight, audioContext, dataArray, dataArrayRight })

		Object.assign(this, { video, canvas, source, audio })

		this.drawPeakFatArrow = () => {
			this.drawPeak()
		}
		window.requestAnimationFrame(this.drawPeakFatArrow)

		log('initVumeter... OK')

		return this
	}
	
	isRunning() {
		return this.audioContext && this.audioContext.state === 'running'
	}
	
	isSuspended() {
		return this.audioContext && this.audioContext.state === 'suspended'
	}

	stop() {
		log('$onDestroy, stoping graphic and audioContext')
		this.stopped = true
		this?.destroy()
		this.audioContext && this.audioContext?.close()
		this.source && this.source?.disconnect()
		delete this.source
		delete this.audioContext
		delete this.meter
	}

	drawPeak() {

		if (this.stopped) {
			return
		}

		const {
			margin,
			high, low,
			canvasContext,
			canvas
		} = this


		const chanelsNumber = 2

		const
			{ width, height } = canvas,
			blockHeight = Math.floor((height + margin) / 14),
			blockWidth = Math.floor((width + margin) / chanelsNumber)

		// clear the background
		canvasContext.clearRect(0, 0, width, height)


		// calculate peak volume
		this.analyser.getByteFrequencyData(this.dataArray)
		this.analyserRight.getByteFrequencyData(this.dataArrayRight)

		const peakUIntLeft = this.dataArray.reduce((prev, current) => current > prev ? current : prev, -500)
		const peakVolumeLeft = peakUIntLeft / 255
		if (peakVolumeLeft > this.clipLevel) {
			this.leftClipTime = performance.now() + this.clipDuration
		}

		const peakUIntRight = this.dataArrayRight.reduce((prev, current) => current > prev ? current : prev, -500)
		const peakVolumeRight = peakUIntRight / 255
		if (peakVolumeRight > this.clipLevel) {
			this.rightClipTime = performance.now() + this.clipDuration
		}


		for (let c = 0; c < chanelsNumber; c++) {

			let peakVolume = c === 0 ? peakVolumeLeft : peakVolumeRight
			let clipTime = c === 0 ? this.leftClipTime : this.rightClipTime


			// draw green
			for (let i = 0; i <= 8; i++) {
				if (peakVolume < 1 / 14 * i) {
					canvasContext.fillStyle = low.green
				} else if (clipTime > performance.now()) {
					canvasContext.fillStyle = high.red
				} else {
					canvasContext.fillStyle = high.green
				}
				canvasContext.fillRect(c * blockWidth, height + margin - (i * blockHeight), blockWidth - margin, blockHeight - margin)

			}
			// draw yellow
			for (let i = 9; i <= 12; i++) {
				if (peakVolume < 1 / 14 * i) {
					canvasContext.fillStyle = low.yellow
				} else if (clipTime > performance.now()) {
					canvasContext.fillStyle = high.red
				} else {
					canvasContext.fillStyle = high.yellow
				}
				canvasContext.fillRect(c * blockWidth, height + margin - (i * blockHeight), blockWidth - margin, blockHeight - margin)
			}
			// draw red
			for (let i = 13; i <= 14; i++) {
				if (peakVolume < 1 / 14 * i) {
					canvasContext.fillStyle = low.red
				} else {
					canvasContext.fillStyle = high.red
				}
				canvasContext.fillRect(c * blockWidth, height + margin - (i * blockHeight), blockWidth - margin, blockHeight - margin)
			}
		}

		// set up the next callback
		window.requestAnimationFrame(this.drawPeakFatArrow)
	}

	checkClipping() {
		return this.clipTime > performance.now()
	}
}